import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';

export const OptionSwitch = Object.freeze({
  ON: 'true',
  OFF: 'false',
});

export const getOptionsByName = (optionName, resp = []) => {
  const optionSet = find(resp, (item) => item && item.name === optionName) || [];
  return (optionSet && optionSet.values) || [];
};

export const getCheckedOption = (optionName, resp = []) => {
  const options = getOptionsByName(optionName, resp);
  return find(options, (option) => (!isUndefined(option.checked) ? option.checked : option.defaultValue));
};

export const getOptionByValue = (optionName, value, resp = []) => {
  const options = getOptionsByName(optionName, resp);
  return find(options, (option) => option && option.value === value);
};

export const getCheckedValue = (optionName, resp = []) => {
  const checkedOption = getCheckedOption(optionName, resp);
  return checkedOption && checkedOption.value;
};
